"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pendo_script_1 = require("./service/pendo-script");
function BerniePluginPendo() {
  return {
    name: 'bernie-plugin-pendo',
    onBrowserHydrateRenderContext: function (context, next) {
      // Grab context, set app data, etc.
      var hydratedState = context.hydratedState,
        setAppData = context.setAppData;
      var pendoInitData = hydratedState.pendoInitData,
        pendoSdkKey = hydratedState.pendoSdkKey;
      setAppData({
        pendoInitData: pendoInitData,
        pendoSdkKey: pendoSdkKey
      });
      return next(context);
    },
    onBrowserWrapRootElement: function (context, next) {
      // Get appData, set root element, etc.
      var appData = context.getAppData();
      if (appData.pendoInitData && appData.pendoSdkKey) {
        (0, pendo_script_1.addScriptToHead)(JSON.stringify(appData.pendoInitData), appData.pendoSdkKey);
      }
      return next(context);
    }
  };
}
exports.default = BerniePluginPendo;